import { atom, useAtom } from "jotai";
import { useCallback } from "react";

export const tokenAtom = atom<string>("");
type FetchMethods = "GET" | "POST";

export const useAPI = () => {
  const [token, setToken] = useAtom(tokenAtom);

  const fetchData = useCallback(
    async (
      url: string,
      body: any = {},
      method: FetchMethods = "GET",
      defaultToken: string | null = null,
    ) => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}${url}`, {
          method: method,
          body: method === "GET" ? undefined : JSON.stringify(body),
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${defaultToken ?? token}`,
          },
        });

        const data = await response.json();

        if (data.errors) {
          return { errors: data.errors };
        } else if (response.status == 401) {
          return { errors: data };
        } else if (response.status < 300) {
          return { data };
        } else {
          return { errors: data };
        }
      } catch (error: any) {
        console.log(error);
        return { errors: { network: "Network Error" } };
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token],
  );

  const getCountries = async () => {
    const { errors, data } = await fetchData("/country/all");
    if (errors) {
      return [];
    }
    return data;
  };

  const sendEmailVerifyCode = async (email: string) => {
    return await fetchData(
      "/verify/send-email-verify-code",
      { email: email },
      "POST",
    );
  };

  const verifyEmail = async (email: string, verify_code: string) => {
    return await fetchData(
      "/verify/email",
      { email: email, verify_code: verify_code },
      "POST",
    );
  };

  const getPageFromRfid = async (rfId: string, secureTag: string) => {
    const { errors, data } = await fetchData(
      "/get-page",
      { rfid: rfId, securetag: secureTag },
      "POST",
    );

    if (errors) {
      return null;
    }
    return data?.page;
  };

  return {
    token,
    setToken,
    fetchData,
    getCountries,
    sendEmailVerifyCode,
    verifyEmail,
    getPageFromRfid,
  };
};
